// locale.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  static localeId: string = 'en-ZA'; // Default locale
  static currencyCode: string = 'ZAR'; // Default currency

  // Set user's locale and currency dynamically, e.g., from login response
  setLocale(locale: string, currency: string) {
    LocaleService.localeId = locale;
    LocaleService.currencyCode = currency;
  }

  getLocale(): string {
    return LocaleService.localeId;
  }

  getCurrencyCode(): string {
    return LocaleService.currencyCode;
  }
}
